import React from 'react';
import ReactDOM from 'react-dom';
import styles from './DeleteConfirmationDialog.module.scss';

interface DeleteConfirmationDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

export const DeleteConfirmationDialog: React.FC<
  DeleteConfirmationDialogProps
> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = 'Delete',
  cancelButtonText = 'Cancel'
}) => {
  if (!isOpen) {
    return null;
  }

  // Split message by newlines and render with spacing
  const renderMessage = () => {
    const parts = message.split('\n').filter(part => part.trim());
    if (parts.length === 1) {
      return <p className={styles.message}>{message}</p>;
    }
    return (
      <div className={styles.message}>
        {parts.map((part, index) => (
          <span
            key={index}
            style={{
              display: 'block',
              marginTop: index > 0 ? '10px' : '0'
            }}
          >
            {part}
          </span>
        ))}
      </div>
    );
  };

  return ReactDOM.createPortal(
    <div
      className={styles.backdrop}
      data-dialog="true"
      onClick={e => {
        // Close if clicking on backdrop
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div className={styles.dialog} data-dialog="true">
        <h2 className={styles.title}>{title}</h2>
        {renderMessage()}
        <div className={styles.buttonContainer}>
          <button
            onClick={onCancel}
            className={styles.cancelButton}
            data-dialog="true"
          >
            {cancelButtonText}
          </button>
          <button
            onClick={onConfirm}
            className={styles.confirmButton}
            data-dialog="true"
          >
            {confirmButtonText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
